"use strict";
// Type definitions for DataTables FixedHeader
//
// Project: https://datatables.net/extensions/fixedheader/, https://datatables.net
// Definitions by:
//   SpryMedia
//   Jared Szechy <https://github.com/szechyjs>
//   Kiarash Ghiaseddin <https://github.com/Silver-Connection>
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=fixedheader.js.map